import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosHttp from "services/axiosHttp";

// CREATE ACTION
export const qrLocationCreate = createAsyncThunk( "qrLocationCreate", async ({data}, { rejectWithValue }) => {
    try {
      const response = await axiosHttp.post("lcqr/createqrlocation", data);
      return response.data;

    } catch (err) {
        if (!err.response) {
            throw err;
        }
        return rejectWithValue(err.response.data);
    }
});

const qrLocationCreateSlice = createSlice({
  name: "qrLocationCreateSlice",
  initialState: {
    isLoading: false,
    isError: false,
    error: null,
    data: null,
  },
  reducers: {
    resetCreateState: (state) => {
      state.isLoading = false;
      state.isError = false;
      state.error = null;
      state.data = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(qrLocationCreate.pending, (state) => {
      state.isLoading = true;
      state.isError = false;
      state.error = null;
    });
    builder.addCase(qrLocationCreate.fulfilled, (state, action) => {
      state.isLoading = false;
      state.isError = false;
      state.data = action.payload;
    });
    builder.addCase(qrLocationCreate.rejected, (state, action) => {
      state.isLoading = false;
      state.isError = true;
      state.error = action.payload;
    });
  },
});

export const { resetCreateState } = qrLocationCreateSlice.actions;
export default qrLocationCreateSlice.reducer;